import { useEffect } from 'react';
/**
 * A hook that will invoke a callback when the user presses one of the given
 * `keys`. To listen to any key pressed, pass `true`.
 *
 * @usage
 * useKeypress(true, e => console.log('User pressed', e.key))
 * useKeypress(['A', 'Escape'], e => console.log('User pressed', e.key))
 */
export default function useKeypress(keys, onKeypress) {
    useEffect(function () {
        var listener = function (e) {
            if (keys === true || keys.includes(e.key)) {
                onKeypress(e);
            }
        };
        document.addEventListener('keydown', listener, false);
        return function () { return document.removeEventListener('keydown', listener, false); };
    }, [onKeypress, keys]);
}
//# sourceMappingURL=index.js.map